module.exports = __webpack_public_path__ + "img/Dantam Hair 28.fdb531ce.jpg";